import { render, staticRenderFns } from "./SlsDL_Sales.vue?vue&type=template&id=210af266"
import script from "./SlsDL_Sales.vue?vue&type=script&lang=js"
export * from "./SlsDL_Sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports